module.exports = __webpack_public_path__ + "img/portrait_phone2.49393b98.png";